import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getComments = (
  objectType,
  objectId,
  commentType = 'default',
  page = 1,
  perPage = 20
) => {
  const params = toParams({
    objectType,
    objectId,
    commentType,
    page,
    perPage,
  });
  return API.get(`/comments/?${params}`);
};

const getComment = (id) => API.get(`/comments/${id}/`);

const postComment = (content, objectId, objectType = 'episode') =>
  API.post('/comments/', {
    content,
    objectId,
    objectType,
  });

const deleteComment = (commentId) => API.delete(`/comments/${commentId}/`);

const hideComment = (commentId) => API.post(`/comments/${commentId}/hide/`);

const fixComment = (commentId, source) =>
  API.post(`/comments/${commentId}/fix/`, { source });

const unfixComment = (commentId, source) =>
  API.post(`/comments/${commentId}/unfix/`, { source });

export default {
  getComments,
  getComment,
  postComment,
  deleteComment,
  hideComment,
  fixComment,
  unfixComment,
};



// WEBPACK FOOTER //
// ./src/app/apis/comment.js